import { makeStyles } from '@material-ui/core';
import React, { useContext } from 'react';
import MessagesContext from '../../contexts/messagesContext';
import { CancelButton } from '../../components/UI';
import ForgetPassword from '../../components/Profile/ForgetPassword';
import UpdateUserInfo from '../../components/Profile/UpdateUserInfo';
import logoutIcon from '../../assets/images/Icon/logOutMobile.svg';
import { useDispatch, useSelector } from 'react-redux';
import {
    deleteWorkspace,
    getNamespace,
    getRefreshToken,
    setSettingItem
} from '../../utils/storage';
import usePermissions from '../../hooks/usePermissions';
import { logout } from '../../redux/User/UserAction';
import AppBar from '../../components/AppBar';
import useCheckMobileScreen from '../../hooks/useWidth';
import ChangeLanguage from '../../components/Profile/ChangeLang';
import LanguageContext from '../../contexts/languageContext';
import { setWeek } from '../../redux/Appointment/AppointmentAction';

const styles = makeStyles({
    container: {
        padding: '24px',
        background: '#fff',
        borderRadius: '6px'
    },
    profileWrapper: {
        background: '#fff'
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '30px',
        flexFlow: 'wrap',
        gap: '40px'
    },
    logout: {
        width: '20px',
        height: '20px',
        marginInlineEnd: '6px'
    },
    accessContainer: {
        display: 'flex',
        alignItems: 'start',
        '& span:first-child': {
            whiteSpace: 'nowrap'
        }
    },
    tagsContainer: {
        display: 'flex',
        flexFlow: 'wrap',
        alignItems: 'center',
        maxWidth: '550px',
        marginInlineStart: '16px'
    },
    tag: {
        background: '#e7ecf2',
        borderRadius: '15px',
        padding: '4px 8px',
        marginInlineEnd: '6px',
        marginBottom: '6px',
        fontSize: '13px',
        fontWeight: 'normal'
    }
});
const Profile = () => {
    const { messages } = useContext(MessagesContext);
    const classes = styles();
    const dispatch = useDispatch();
    const namespace = getNamespace();
    const isMobile = useCheckMobileScreen();
    const { lang, setLang } = useContext(LanguageContext);
    const date = useSelector((state) => state.appointment?.date?.selected);
    const userAccess = useSelector(
        (state) => state.user?.userInfo?.namespaces?.find((item) => item.id === namespace)?.access
    );
    const userPermissions = Object.keys(userAccess?.permissions).filter(
        (key) => userAccess.permissions[key] && !key.startsWith('delegate')
    );
    const { permissions: allPermissions } = usePermissions();
    const filterPermissions = allPermissions?.filter((permission) =>
        userPermissions?.find((userPermission) => userPermission === permission.name)
    );

    const handleSwitchLanguage = () => {
        let selectedLang;
        if (lang === 'en') {
            selectedLang = 'fa';
            setLang('fa');
        } else {
            selectedLang = 'en';
            setLang('en');
        }
        setSettingItem('lang', selectedLang);
        dispatch(setWeek(date));
    };

    const handleLogOut = () => {
        const refresh = getRefreshToken();
        dispatch(logout({ refresh }));
        deleteWorkspace();
    };

    return (
        <>
            {isMobile && <AppBar title={messages.profile} />}
            <div
                className={
                    isMobile ? `${classes.profileWrapper} mobileContainer` : classes.container
                }
            >
                <div className={classes.row}>
                    <h3>{messages.profile}</h3>
                    <CancelButton width="130" onClick={handleLogOut} data-testid="logOut">
                        <img src={logoutIcon} alt="logout" className={classes.logout} />
                        {messages.logout}
                    </CancelButton>
                </div>
                <div className={classes.row}>
                    <UpdateUserInfo />
                    <ForgetPassword />
                </div>
                <div>
                    <div className={classes.accessContainer}>
                        <span>{messages.permission}</span>
                        <div className={classes.tagsContainer}>
                            {filterPermissions?.map((item) => (
                                <span className={classes.tag} key={item.id}>
                                    {item.title}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
                <div>
                    <ChangeLanguage lang={lang} handleChange={handleSwitchLanguage} />
                </div>
            </div>
        </>
    );
};

export default Profile;
